import { QueryInterface } from "qpr-base/querybuilder/QueryBuilder";
import { findYearsLastPeriod } from "./model/findYearsLastPeriod";
import { IPeriodLevel } from "./model/model";

type Params = Parameters<QueryInterface["attributes"]>;
type FParams = (
  period: string | undefined,
  allPeriods: IPeriodLevel[]
) => Params;

// prettier-ignore
const defaultAttributes: FParams = (period: string|undefined, allPeriods: IPeriodLevel[]) => {
  const lastPeriod = period && allPeriods ? findYearsLastPeriod(period, allPeriods) : undefined;  
    const items = [
    "name",
    "periodlevel",
    "periodlevelid",
    "valuesettingsname",
    "description",
    "symbol",
    "periodlevelname",
    ["hasreferencescorecard", {as: "isreference"}],
    ["periodname", { period, as: "periodname" }],
    "owner",
    "topelement",
    ["scorecard.topelement", { as: "top_element_id" }],
    "level",
    "index",
    "childobjects",

    ["scorecard.name", { as: "scorecardname" }],
    ["scorecard.symbol", { as: "scorecardsymbol" }],

    ["rangecolor", { period: period, as: "rangecolor" }],
    ["rangename", { period: period, as: "rangename" }],
    ["rangevalue", { period: period, as: "rangevalue" }],

    ["trend", { period }],
    
    ["measure.parent.name", { as: "parentName" }],
    ["measure.parent.typename", { as: "parentTypename" }],
    ["measure.parent.symbol", { as: "parentSymbol"}],
    ["measure.parent.description", { as: "parentDescription" }],

    ["value", { series: "JS_ATTR", as: "JS_ATTR", period: "latestforseries"}],
    
    ["value", { series: "PERF", as: "PERF", period }],
    ["valuewithoutsymbol", { series: "PERF", as: "PERF_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "PERF", as: "PERF_prettyvalue", period }],
    ["unit", { series: "PERF", as: "PERF_unit" }],
    ["rangecolor", { series: "PERF", as: "PERF_rangecolor", period }],

    ["value", { series: "FRC", as: "FRC", period }],
    ["valuewithoutsymbol", { series: "FRC", as: "FRC_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "FRC", as: "FRC_prettyvalue", period }],
    ["unit", { series: "FRC", as: "FRC_unit" }],
    ["rangecolor", { series: "FRC", as: "FRC_rangecolor", period }],

    ["value", { series: "PERF_YTD", as: "PERF_YTD", period }],
    ["valuewithoutsymbol", { series: "PERF_YTD", as: "PREF_YTD_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "PERF_YTD", as: "PERF_YTD_prettyvalue", period }],
    ["unit", { series: "PERF_YTD", as: "PERF_YTD_unit" }],
    ["rangecolor", { series: "PERF_YTD", as: "PERF_YTD_rangecolor", period }],

    ["value", { series: "SCORE", as: "SCORE", period }],
    ["valuewithoutsymbol", { series: "SCORE", as: "SCORE_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "SCORE", as: "SCORE_prettyvalue", period }],
    ["unit", { series: "SCORE", as: "SCORE_unit" }],
    ["rangecolor", { series: "SCORE", as: "SCORE_rangecolor", period }],

    ["value", { series: "SCORE_YTD", as: "SCORE_YTD", period }],
    ["valuewithoutsymbol", { series: "SCORE_YTD", as: "SCORE_YTD_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "SCORE_YTD", as: "SCORE_YTD_prettyvalue", period }],
    ["unit", { series: "SCORE_YTD", as: "SCORE_YTD_unit" }],
    ["rangecolor", { series: "SCORE_YTD", as: "SCORE_YTD_rangecolor", period }],

    ["value", { series: "SCORE_YTD_CON", as: "SCORE_YTD_CON", period }],
    ["valuewithoutsymbol", { series: "SCORE_YTD_CON", as: "SCORE_YTD_CON_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "SCORE_YTD_CON", as: "SCORE_YTD_CON_prettyvalue", period }],
    ["unit", { series: "SCORE_YTD_CON", as: "SCORE_YTD_CON_unit" }],
    ["rangecolor", { series: "SCORE_YTD_CON", as: "SCORE_YTD_CON_rangecolor", period }],
    
    ["value", { series: "ACT", as: "ACT", period }],
    ["valuewithoutsymbol",{ series: "ACT", as: "ACT_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "ACT", as: "ACT_prettyvalue", period }],
    ["unit", { series: "ACT", as: "ACT_unit" }],
    ["unitname", { series: "ACT", as: "ACT_unitname" }],
    ["rangecolor", { series: "ACT", as: "ACT_rangecolor", period }],
    
    ["value", { series: "ACT_YTD", as: "ACT_YTD", period }],
    ["valuewithoutsymbol", { series: "ACT_YTD", as: "ACT_YTD_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "ACT_YTD", as: "ACT_YTD_prettyvalue", period }],
    ["unit", { series: "ACT_YTD", as: "ACT_YTD_unit" }],
    ["rangecolor", { series: "ACT_YTD", as: "ACT_YTD_rangecolor", period }],

    ["value", { series: "TAR_YTD", as: "TAR_YTD", period }],
    ["valuewithoutsymbol", { series: "TAR_YTD", as: "TAR_YTD_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "TAR_YTD", as: "TAR_YTD_prettyvalue", period }],
    ["unit", { series: "TAR_YTD", as: "TAR_YTD_unit" }],

    ["value", { series: "PERF_W_YTD", as: "PERF_W_YTD", period }],
    ["valuewithoutsymbol", { series: "PERF_W_YTD", as: "PERF_W_YTD_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "PERF_W_YTD", as: "PERF_W_YTD_prettyvalue", period }],
    ["unit", { series: "PERF_W_YTD", as: "PERF_W_YTD_unit" }],

    ["value", { series: "PERF_YTD_OPEN", as: "PERF_YTD_OPEN", period }],
    ["valuewithoutsymbol", { series: "PERF_YTD_OPEN", as: "PERF_YTD_OPEN_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "PERF_YTD_OPEN", as: "PERF_YTD_OPEN_prettyvalue", period }],
    ["unit", { series: "PERF_YTD_OPEN", as: "PERF_YTD_OPEN_unit" }],

    ["value", { series: "PERF_AVG_YTD", as: "PERF_AVG_YTD", period }],
    ["valuewithoutsymbol", { series: "PERF_AVG_YTD", as: "PERF_AVG_YTD_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "PERF_AVG_YTD", as: "PERF_AVG_YTD_prettyvalue", period }],
    ["unit", { series: "PERF_AVG_YTD", as: "PERF_AVG_YTD_unit" }],

    ["value", { series: "W", as: "W", period }],
    ["valuewithoutsymbol", { series: "W", as: "W_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "W", as: "W_prettyvalue", period }],
    ["unit", { series: "W", as: "W_unit" }],

    ["value", { series: "COMPLETION_PERCENTAGE", as: "COMPLETION_PERCENTAGE", period }],
    ["valuewithoutsymbol", { series: "COMPLETION_PERCENTAGE", as: "COMPLETION_PERCENTAGE_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "COMPLETION_PERCENTAGE", as: "COMPLETION_PERCENTAGE_prettyvalue", period }],
    ["unit", { series: "COMPLETION_PERCENTAGE", as: "COMPLETION_PERCENTAGE_unit" }],
    ["unitname", { series: "COMPLETION_PERCENTAGE", as: "COMPLETION_PERCENTAGE_unitname" }],
    
    ["value", { series: "PLANNED_COMPLETION", as: "PLANNED_COMPLETION", period }],
    ["valuewithoutsymbol", { series: "PLANNED_COMPLETION", as: "PLANNED_COMPLETION_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "PLANNED_COMPLETION", as: "PLANNED_COMPLETION_prettyvalue", period }],
    ["unit", { series: "PLANNED_COMPLETION", as: "PLANNED_COMPLETION_unit" }],
    ["unitname", { series: "PLANNED_COMPLETION", as: "PLANNED_COMPLETION_unitname" }],
    
    ["value", { series: "BUDGET", as: "BUDGET", period }],
    ["prettyvalue", { series: "BUDGET", as: "BUDGET_prettyvalue", period }],
    
    ["value", { series: "BUDGET_UTIL", as: "BUDGET_UTIL", period }],
    ["prettyvalue", { series: "BUDGET_UTIL", as: "BUDGET_UTIL_prettyvalue", period }],

    ["value", { series: "START_DATE", as: "START_DATE", period }],
    ["prettyvalue", { series: "START_DATE", as: "START_DATE_prettyvalue", period }],
    
    ["value", { series: "END_DATE", as: "END_DATE", period }],
    ["prettyvalue", { series: "END_DATE", as: "END_DATE_prettyvalue", period }],
    ["unitname", { series: "END_DATE", as: "END_DATE_unitname" }],
    
    ["value", { series: "ACTUAL_START_DATE", as: "ACTUAL_START_DATE", period }],
    ["prettyvalue", { series: "ACTUAL_START_DATE", as: "ACTUAL_START_DATE_prettyvalue", period }],
    
    ["value", { series: "ACTUAL_END_DATE", as: "ACTUAL_END_DATE", period }],
    ["prettyvalue", { series: "ACTUAL_END_DATE", as: "ACTUAL_END_DATE_prettyvalue", period }],

    ["value", { series: "SLIPPAGE", as: "SLIPPAGE", period }],
    ["prettyvalue", { series: "SLIPPAGE", as: "SLIPPAGE_prettyvalue", period }],
    ["unit", { series: "SLIPPAGE", as: "SLIPPAGE_unit" }],
    ["valuewithoutsymbol", { series: "SLIPPAGE", as: "SLIPPAGE_valuewithoutsymbol", period }],

    ["value", { series: "VARIANCE", as: "VARIANCE", period }],
    ["valuewithoutsymbol", { series: "VARIANCE", as: "VARIANCE_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "VARIANCE", as: "VARIANCE_prettyvalue", period }],
    ["unit", { series: "VARIANCE", as: "VARIANCE_unit" }],
      
    ["value", { series: "EXPENDITURE", as: "EXPENDITURE", period }],
    ["valuewithoutsymbol", { series: "EXPENDITURE", as: "EXPENDITURE_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "EXPENDITURE", as: "EXPENDITURE_prettyvalue", period }],
    ["unit", { series: "EXPENDITURE", as: "EXPENDITURE_unit" }],
    ["unitname", { series: "EXPENDITURE", as: "EXPENDITURE_unitname" }],
    
    ["value", { series: "PERF_W", as: "PERF_W", period }],
    ["prettyvalue", { series: "PERF_W", as: "PERF_W_prettyvalue", period }],
    ["unit", { series: "PERF_W", as: "PERF_W_unit" }],
    
    ["value", { series: "TAR", as: "TAR", period }],
    ["valuewithoutsymbol",{ series: "TAR", as: "TAR_valuewithoutsymbol", period }],
    ["prettyvalue", { series: "TAR", as: "TAR_prettyvalue", period }],
    ["unit", { series: "TAR", as: "TAR_unit" }],
    ["unitname", { series: "TAR", as: "TAR_unitname" }],
    
    ["value", { series: "ALA", as: "ALA", period }],
    ["valuewithoutsymbol",{ series: "ALA", as: "ALA_valuewithoutsymbol", period }],
    ["unit", { series: "ALA", as: "ALA_unit" }],

    ["valuewithoutsymbol", { series: "TARGET_VARIANCE", as: "TARGET_VARIANCE_valuewithoutsymbol", period }],
    ["valuewithoutsymbol", { series: "ALARM_VARIANCE", as: "ALARM_VARIANCE_valuewithoutsymbol", period }],
  ];

  for (let i = 0; i < items.length; i += 1) {
    if (Array.isArray(items[i]) && (items[i][1] as any).period) {
      (items[i][1] as any)["resolveui2period"] = "true"
    }
  }

 if(lastPeriod) {
  items.push(  ["prettyvalue", { series: "TAR_YTD", as: "TAR_YEAR_END_YTD_prettyvalue", period:lastPeriod?.name || 'latestforseries' }] )
 } else {
  items.push(  ["prettyvalue", { series: "TAR_YTD", as: "TAR_YEAR_END_YTD_prettyvalue", period: '12 / 2023' }] )

 }

 return items as any;
}

export default defaultAttributes;
